module.exports = __webpack_public_path__ + "static/media/__logo.37a52c29.png";